export enum PurchaseOrderStatus {
  DRAFT = "draft",
  PENDING_APPROVAL = "pending_approval",
  APPROVED = "approved",
  FULFILLED = "fulfilled",
  COMPLETED = "completed",
  CANCELLED = "cancelled"
}

export const PurchaseOrderStatusLabel = {
  [PurchaseOrderStatus.DRAFT]: 'Borrador',
  [PurchaseOrderStatus.PENDING_APPROVAL]: 'Pendiente de Aprobación',
  [PurchaseOrderStatus.APPROVED]: 'Aprobada',
  [PurchaseOrderStatus.FULFILLED]: 'Entregada',
  [PurchaseOrderStatus.COMPLETED]: 'Completada',
  [PurchaseOrderStatus.CANCELLED]: 'Cancelada'
};
